// ActivityTabs.jsx
import React from 'react';
import SurveyPieChart from './SurveyPieChart';
import { HiUserCircle } from 'react-icons/hi';
import { HiArrowTopRightOnSquare, HiOutlineBookOpen } from "react-icons/hi2";
import { BsCopy } from "react-icons/bs";
import { FaUsersBetweenLines } from "react-icons/fa6";
import { TbReportAnalytics } from "react-icons/tb";
import { PiMonitorPlay } from "react-icons/pi";
import { toast } from 'react-toastify';

export const ActivitiesContent = ({ userDetails, statusData, surveyAns }) => {

  let objStatus = {
    introMeetingLink: statusData?.introMeetingLink || "",
    caseStudyMeetingLink: statusData?.caseStudyMeetingLink || "",
    rolePlayMeetingLink: statusData?.rolePlayMeetingLink || "",
    isSurveyComplete: statusData?.isSurveyComplete || false
  };

  const activitiesData = [
    { id: 1, type: 'Meeting', name: 'Introduction & AC Manager Assistance', icon: FaUsersBetweenLines, meetingLink: objStatus["introMeetingLink"] },
    { id: 2, type: 'Meeting', name: 'Behavioral Event Interview (BEI)', icon: HiOutlineBookOpen, meetingLink: objStatus["caseStudyMeetingLink"] },
    { id: 3, type: 'Meeting', name: 'Subordinate Role Play Meeting', icon: PiMonitorPlay, meetingLink: objStatus["rolePlayMeetingLink"] },
    // { id: 4, type: 'Survey', name: 'Survey', icon: TbReportAnalytics, status: objStatus["isSurveyComplete"] ? 'Completed' : 'Pending' }
  ];

  let goToLink = (meetLink) => {
    window.open(meetLink, "_blank");
  };

  let handleCopy = (text) => {
    toast("Meeting Link Copied!")
    if (!text) return;
    navigator.clipboard.writeText(text);
  };


  const logicCal = (ansList) => {
    let value = 0;
    if (ansList && ansList.length > 0) {
      const total = ansList.reduce(
        (acc, i) => acc + i.weightage,
        0
      );

      const avg = total / surveyAns.length;

      // percentage out of max 6
      value = Number((((avg / 6) * 100)).toFixed(2));
    }

    return value;
  };


  let value = logicCal(surveyAns);


  return (
    <div className="flex flex-col p-4 lg:p-6 bg-white overflow-y-auto h-full">

      <div className="flex items-center justify-between lg:p-6 p-3 border border-gray-300 rounded-md">
        <div className="flex items-center gap-4">
          <HiUserCircle className="text-indigo-600 lg:w-20 lg:h-20 w-16 h-16" />
          <div>
            <h2 className="lg:text-lg text-base font-bold textblack">{userDetails.name}</h2>
            <p className="textblack text-sm">{userDetails.email}</p>
          </div>
        </div>
        {value > 0 ?
          <>
            <div className="flex-row items-center gap-4 md:flex hidden">
              {value > 0 && <SurveyPieChart value={value} />}
              <div>
                <h2 className="text-2xl font-bold text-green-500">{value}%</h2>
                <p className="text-gray-900 text-sm">Survey Score</p>
              </div>
            </div>
          </>
          : null}

      </div>

      <div className="flex items-center justify-between lg:p-6 p-4 border border-gray-300 rounded-md md:hidden mt-4">
        <div className="flex items-center gap-4 md:block">
          {value > 0 && <SurveyPieChart value={value} />}
          <div>
            <h2 className="text-2xl font-bold text-green-500">{value}%</h2>
            <p className="text-gray-900 text-sm">Survey Score</p>
          </div>
        </div>
      </div>

      {/* Activities List */}
      <div className="mt-3 pb-20">
        <h3 className="text-2xl font-bold textblack mb-4 mt-4">Activities</h3>
        <div className="space-y-3">
          {activitiesData.map((activity) => {
            const Icon = activity.icon;
            return (
              <div key={activity.id} className="flex xl:flex-row xl:items-center flex-col items-start xl:space-y-0 space-y-4 md:p-6 p-4 bg-white rounded-md border border-gray-300 hover:shadow-md transition-all">
                {/* Icon & Details */}
                <div className="flex items-center gap-5 flex-grow">
                  <div className="p-2 bg-purple-100 rounded-2xl">
                    <Icon size={42} className="text-indigo-600" />
                  </div>
                  <div>
                    <span className="text-sm font-medium text-indigo-600">{activity.type}</span>
                    <h4 className="text-lg font-semibold textblack mt-1 whitespace-nowrap">{activity.name}</h4>
                  </div>
                </div>

                {/* Actions or Status */}
                <div className="mt-5 sm:mt-0 flex gap-3 flex-shrink-0">
                  {activity.type === "Survey" ? (
                    <>
                      {/* <span className={(activity.status === "Completed" ? "bg-indigo-600 text-white " : "border border-gray-300 text-indigo-600") + " px-6 py-2.5 font-medium rounded-lg text-base"}>{activity.status}</span> */}

                      <div className="flex items-center gap-3">
                        <span
                          className={`px-8 py-2.5 rounded-md md:text-sm text-xs font-medium ${activity.status === "Completed"
                            ? "bg-green-500 text-white"
                            : "bg-yellow-500 text-white"
                            }`}
                        >
                          {activity.status}
                        </span>
                        <span className="text-gray-900 text-sm">
                          5th May, 2026 | 12:50 AM
                        </span>
                      </div>
                    </>
                  ) : (
                    <>
                      <button onClick={() => goToLink(activity.meetingLink)} className="flex items-center gap-2 md:px-5 px-3 py-2.5 bg-indigo-600 text-white rounded-md font-medium transition-colors md:text-sm text-xs">
                        <span>Join Meeting Link</span>
                        <HiArrowTopRightOnSquare size={22} />
                      </button>
                      <button title="Copy Meeting Link" onClick={() => handleCopy(activity.meetingLink)}
                        className="flex items-center gap-2 md:px-5 px-3 py-2.5 border border-gray-300 text-indigo-600 hover:bg-gray-100 active:scale-95 active:bg-indigo-100 rounded-md font-medium transition-all duration-150 md:text-sm text-xs">
                        <BsCopy size={18} />
                        {/* <span>Copy Meeting Link</span> */}
                      </button>
                    </>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};